import CustomSwitchArea from "./CustomSwitchArea";

export default CustomSwitchArea;
